export default "#version 300 es\nprecision mediump float;\n\nin vec4 v_color;\nout vec4 fragColor;\n\nvoid main() {\n  fragColor = v_color;\n}\n"